import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';

export var DashboardTools = {
	
	showWidgetOptions(widgetConfig, options) {
		
		var record = widgetConfig;
		
		var configWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Configure Widget',
			icon: 'vaadin:cog',
			width: 600,
			height: 400,
			listeners: {
				ready: function () {
					configWin.show();

					var colorInput = {
						tag: 'input',
						type: 'color',							
						listeners: {
							change: function(event) {
								event.target.title = event.target.value; 
							}
						}
					};
					
					var propertiesConfigs = [];
					if (options.configProperties) {
						propertiesConfigs.push({
							tag: 'legend',
							innerHTML: 'Options'
						});
						
						//look at the widget definition to determine additional properites
						
					}					

					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'vaadin-text-field',
										name: 'name',
										label: 'Name',
										required: true,
										maxLength: 35
									},
									{
										tag: 'vaadin-custom-field',
										label: 'Header Background Color',
										name: 'titleColor',										
										children: [
											Object.assign({title: record.titleColor ? record.titleColor : '#253746'}, colorInput)
										]
									},									
									{
										tag: 'vaadin-custom-field',
										label: 'Header Text Color',
										name: 'titleTextColor',										
										children: [
											Object.assign({title: record.titleTextColor ? record.titleTextColor : '#ffffff'}, colorInput)
										]
									},	
									{
										tag: 'vaadin-number-field',
										name: 'columnSpan',
										label: 'Column Span',
										'has-controls': true,
										required: true,
										value: 1,
										min: 1,
										max: 2 
									},
									{
										tag: 'fieldset',
										'class': (options.configProperties ? '' : 'hide'),
										children: propertiesConfigs,
										colspan: 2
									},									
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:database', ' Save')
												],
												listeners: {
													click: function () {
														
														if (formPanel.isValid()) {
															var data = formPanel.getData();														
															widgetConfig.name = data.name;
															widgetConfig.titleColor = data.titleColor;
															widgetConfig.titleTextColor = data.titleTextColor;
															widgetConfig.columnSpan = data.columnSpan;

															widgetConfig.properties  = widgetConfig.properties || {};														
															for (var key in data) {
																if (key !== 'name' &&
																	key !== 'titleColor' &&
																	key !== 'titleTextColor' &&
																	key !== 'columnSpan') {																
																	widgetConfig.properties[key] = data[key];
																}
															}
															configWin.close();

															options.handlerApplyConfig(data);														
														}
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function () {
														//cancel														
														configWin.close();
														options.handlerCancel();
													}
												}
											}
										]
									}
								]
							}
						]
					});

					configWin.addToContentElement(formPanel);

					if (record) {
						formPanel.load(record);
					}

				}
			}
		});			
		
	}
		
};


